import { useCallback } from "react";

import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import CopyFieldDropdownMenuItem from "components/CopyField/DropdownMenuItem";
import useCanDeleteContext from "shared/Context/access/useCanDeleteContext";
import useCanUpdateContext from "shared/Context/access/useCanUpdateContext";
import { openContextUpdateDrawer } from "views/Account/Contexts/UpdateDrawer";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Context } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";

import ContextsDeleteDropdownItem from "../../DeleteDropdownItem";

const ContextsTableRowActionsCell = ({
  item: context,
  ...cellProps
}: TableSimpleCellProps<Context>) => {
  const canDeleteContext = useCanDeleteContext()(context);
  const canUpdateContext = useCanUpdateContext()(context);

  const handleOnEdit = useCallback(() => {
    openContextUpdateDrawer({
      context,
      refetchQuery: "SearchContexts",
      id: context.id,
    });
  }, [context]);

  return (
    <TableSimpleCell {...cellProps}>
      <DropdownMenuEllipsis tooltip="Context actions">
        {(canUpdateContext.result || canUpdateContext.message) && (
          <DropdownMenuItem
            onAction={handleOnEdit}
            isDisabled={!canUpdateContext.result}
            tooltip={canUpdateContext.message}
            tooltipPlacement="left"
          >
            Edit
          </DropdownMenuItem>
        )}

        <CopyFieldDropdownMenuItem title="Copy ID" value={context.id} />
        {(canDeleteContext.result || canDeleteContext.message) && (
          <ContextsDeleteDropdownItem
            hasAttachedEntities={context.hasAttachedStacks}
            id={context.id}
            name={context.name}
            isDisabled={!canDeleteContext.result}
            tooltip={canDeleteContext.message}
          />
        )}
      </DropdownMenuEllipsis>
    </TableSimpleCell>
  );
};

export default ContextsTableRowActionsCell;
